import { motion } from "framer-motion";
import { Gift, Bot, Radar, Target } from "lucide-react";
import { fadeUp, viewport } from "@/components/anim";

const CHAPTERS = [
  {
    id: "perk-card-airdrops",
    no: "01",
    icon: Gift,
    title: "Pre-Public Token Airdrops",
    body: "Members receive fresh token allocations directly to their wallet before the pair ever goes live on a public DEX. You are the exit liquidity for nobody.",
    span: "lg:col-span-3",
    accent: "#14F195",
  },
  {
    id: "perk-card-bots",
    no: "02",
    icon: Bot,
    title: "Custom Sniper Bots",
    body: "Sub-millisecond MEV & auto-buy bots configured for your wallet. Snipe launches the instant liquidity is added — no fat fingers, no missed blocks.",
    span: "lg:col-span-3",
    accent: "#9945FF",
  },
  {
    id: "perk-card-whales",
    no: "03",
    icon: Radar,
    title: "Tier-1 Whale Tracking",
    body: "Live feeds on the smartest wallets on Solana. When they accumulate, you get pinged in real time — before the chart even flinches.",
    span: "lg:col-span-2",
    accent: "#00F0FF",
  },
  {
    id: "perk-card-accuracy",
    no: "04",
    icon: Target,
    title: "98.4% Signal Accuracy",
    body: "Every call is logged, timestamped and verifiable on-chain. No deleted messages, no fake screenshots — just a receipt-backed track record.",
    span: "lg:col-span-4",
    accent: "#FFD700",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 sm:py-32 bg-[#05060A]"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="max-w-3xl mb-14"
        >
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#14F195]">
            / The Insider Edge
          </span>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            Four reasons the herd never catches up.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-6 gap-5">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.id}
              data-testid={c.id}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              className={`cyber-border glass rounded-3xl p-8 relative overflow-hidden group ${c.span}`}
            >
              <div
                className="absolute -top-8 -right-6 font-display font-black text-8xl opacity-[0.06] group-hover:opacity-[0.12] transition-opacity duration-500"
                style={{ color: c.accent }}
              >
                {c.no}
              </div>
              <div
                className="inline-flex items-center justify-center w-12 h-12 rounded-xl mb-6"
                style={{ background: `${c.accent}1a`, border: `1px solid ${c.accent}33` }}
              >
                <c.icon className="w-6 h-6" style={{ color: c.accent }} />
              </div>
              <h3 className="font-display font-bold text-xl text-white mb-3">{c.title}</h3>
              <p className="text-[#94A3B8] leading-relaxed text-sm sm:text-base max-w-xl">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
